import { requestWithToken } from '../utilities/request';

const path = '/api/private/fields';

/**
 * @param fieldId {int}
 */
const list = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_urls`),
  });
};

/**
 * @param fieldId {int}
 * @param param {object}
 */
const bulkUpdate = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/${fieldId}/field_urls/bulk_update`,
    data: param,
  });
};

export const FieldUrlsService = {
  list,
  bulkUpdate,
};



// WEBPACK FOOTER //
// ./src/services/FieldUrls.js